import React, {Component} from "react";
import CdmLayout from "./../../../templates/cdm";
import {NavLink} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";
import _ from "lodash";
import directoryList from "./../../json/users";

export class PersonsDirectory extends Component {
	render() {
		return (<div className="columns">
			<div className="column no-padding-column">
				<table className="inm-table cdm">
					<thead>
					<tr>
						<th>ID</th>
						<th>Clave</th>
						<th>Nombre</th>
						<th>Type</th>
						<th>Polygon</th>
						<th>Estatus</th>
					</tr>
					</thead>
					<tbody>
					{_.map(directoryList.data, (row, r) => {
						return <tr key={`user-directory-row-${r}`}>
							<td>
								<div className="actions">
									<NavLink to={`/cdm/directorio/personas/editar/${row.id}`}><i className="fa fa-edit" /></NavLink>
									<button onClick={() => this._getConfirm(1, row.name)}><i className="fa fa-trash-o" /></button>
								</div>
								{row.id}
							</td>
							<td><strong>{row.code}</strong></td>
							<td><strong>{`${row.name} ${row.last_name} ${row.slast_name}`}</strong></td>
							<td>{row.type}</td>
							<td>{row.polygon.name}</td>
							<td>{row.status}</td>
						</tr>
					})}
					</tbody>
				</table>
			</div>
		</div>);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la actividad ${name}?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => console.log('ELIMINAR ITEM', id)
		})
	}
}

export default CdmLayout(PersonsDirectory, {
	title: 'Directorio de usuarios',
	subnav: {
		icon: 'fa-calendar-check-o',
		name: 'Planear',
		actions: [
		]
	},
	stateNav: true,
	progress: true
});


// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/directory/index.jsx